

















































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Breadcrumbs from '@/layouts/NavBreadcrumbs.vue'
import { Capacitor } from '@capacitor/core'
import { getMenuItems } from '@/services/cms'

@Component({
  components: {
    Breadcrumbs,
  },
})
export default class Toolbar extends Vue {
  @Prop({ default: false }) drawer!: boolean
  
  menu = false
  cmsMenuItems: any = {}

  async mounted() {
    const menuItems = await getMenuItems()
    menuItems.forEach((item: any) => {
      this.cmsMenuItems[item.attributes.label] = item.attributes
      this.$forceUpdate()
    })
  }
  
  get bottomToolbar() {
    return this.mobileLayout && !this.$route.meta?.landing
  }

  get logo() {
    const mini = this.$store.state.app.preferences.miniNav
    const logotype = (this.$vuetify.theme.dark ? 'logotype-dark' : 'logotype')
    return (mini && !this.$route.meta?.landing) ? 'icon' : logotype
  }

  get mediumLayout() {
    return this.$vuetify.breakpoint.mdAndDown
  }

  get mobileLayout() {
    return this.$vuetify.breakpoint.smAndDown
  }

  get authenticated() {
    return !!this.$store.getters.me
  }

  get links() {
    return [
      {
        label: 'Home',
        to: 'home',
        hide: !this.mobileLayout,
      },
      {
        label: 'About',
        to: 'about',
      },
      {
        label: 'Pricing',
        to: 'pricing',
        hide: Capacitor.isNativePlatform(),
      },
      {
        label: 'Features',
        submenu: 'cms',
      },
      {
        label: 'Industries',
        submenu: 'cms',
      },
      {
        label: 'Resources',
        submenu: 'cms',
      },
      // {
      //   label: 'Contact us',
      //   to: 'contact',
      // },
      // {
      //   label: 'Submenu hardcoded',
      //   submenu: [
      //     {
      //       label: 'Pricing',
      //       to: 'pricing',
      //     }
      //   ]
      // },
      // {
      //   label: "Support",
      //   to: "support",
      // },
      {
        label: 'Sign in',
        to: 'signIn',
        hide: this.authenticated,
      },
      {
        label: 'Sign up',
        to: 'signUp',
        hide: !this.mobileLayout || this.authenticated,
      },
    ]
  }
}
